// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__17IuP","title":"AfterBackImages_title__15axK","images":"AfterBackImages_images__PFL_P"};